<template>
	<div class="m-scroll-image">
		<div class="m-scroll-image-head flex-between-center">
			<p :style="{'font-size': `${(unitData.title_size || 36) / 2}px`}">{{unitData.title_text}}</p>
			<span v-if="unitData.more_link" class="more">{{unitData.more_text || '查看更多'}}</span>
		</div>
		<div class="m-scroll-image-list flex">
			<ul class="flex">
				<li v-for="(item, i) in unitData.list" :key="i" :style="{'width': `${item.img_width / 2}px`}">
					<sub-image :src="item.img_url" :style="{'height': `${item.img_height / 2}px`}"></sub-image>
					<p v-if="unitData.show_list_title == 1">{{item.title}}</p>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				unitData: {}
			}
		},
		
		mounted() {
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	.m-scroll-image {
		border-radius: 10px;
		padding-bottom: 10px;
		margin: 0 12px;
		overflow: hidden;
		background: #fff;
		
		&-head {
			box-sizing: border-box;
			height: 40px;
			padding: 6px 12px 0;
			
			p {
				font-size: 18px;
				font-weight: bold
			}
			
			.more {
				font-size: 12px;
				color: #999;
			}
		}
		
		&-list {
			padding-top: 6px;
			margin: 0 12px;
			overflow: hidden;
			
			ul {
				float: left;
				
				li {
					&:nth-child(n+2) {
						margin-left: 12px;
					}
					
					p {
						line-height: 35px;
						font-size: 13px;
						text-align: center;
						color: #333;
					}
				}
			}
		}
	}
</style>
